module.exports = __webpack_public_path__ + "img/radio-sarawak.85bf48b9.jpg";